export default {
  WIDGET: 'widget',
  FULL_SCREEN_MODALS: 'full-screen-modals',
  DASHBOARD: 'dashboard',
};
